<template>
  <div class="embedContainer bottom">
    <iframe
      allowfullscreen
      frameborder="0"
      :src="src"
    ></iframe>
  </div>
</template>
<script>
  export default {
    name: 'iframe-video-player',
    props: {
      src: {
        type: String,
        required: true
      }
    }
  }
</script>
<style scoped lang="less">
  .embedContainer {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// IframeVideoPlayer.vue?54e676dd